<template>
    <div class="columns is-centered">
        <div class="column is-half">
            <div v-if="isAuthenticated" class="box">
                <div v-if="successfullyRegistered" class="content">
                    <h1 class="is-size-1">{{ lang('Welcome') }}</h1>

                    <p>{{ lang('Your registration was successfull.') }}</p>

                    <a :href="redirectPath" class="button is-primary">{{ lang('Continue') }}</a>
                </div>

                <div v-else class="content">
                    <h1 class="is-size-1">{{ lang('Hello, again') }}</h1>

                    <p>{{ lang('You are already registered and logged in.') }}</p>

                    <a href="/" class="button is-primary">{{ lang('To the Calendar!') }}</a>
                </div>
            </div>

            <div v-else>
                <h1 class="is-size-1">{{ lang('Register') }}</h1>

                <form class="form-horizontal" @submit.prevent="onSubmit">
                    <div class="field">
                        <label class="label">{{ lang('Full Name') }}</label>
                        <div class="control">
                            <input v-model="form.name" class="input" :class="{'is-danger': formErrors.name}" type="text" name="name" required>
                        </div>
                        <p v-show="formErrors.name" v-for="error in formErrors.name" :key="error" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">{{ lang('Email') }}</label>
                        <div class="control">
                            <input v-model="form.email" class="input" :class="{'is-danger': formErrors.email}" type="email" name="email" required>
                        </div>
                        <p v-show="formErrors.email" v-for="error in formErrors.email" :key="error" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>

                    <div class="field">
                        <label for="password" class="label">{{ lang('Password') }}</label>
                        <div class="control">
                            <input v-model="form.password" id="password" type="password" class="input" :class="{'is-danger': formErrors.password}" name="password" required>
                        </div>
                        <p v-show="formErrors.password" v-for="error in formErrors.password" :key="error" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>

                    <div class="field">
                        <label for="password-confirm" class="label">{{ lang('Confirm Password') }}</label>
                        <div class="control">
                            <input v-model="form.password_confirmation" id="password-confirm" type="password" class="input" name="password_confirmation" required>
                        </div>
                    </div>

                    <div class="field">
                        <label for="event-notifications" class="checkbox">
                            <input v-model="form.event_notifications" id="event-notifications" type="checkbox" name="event_notifications" autocomplete="off">
                            {{ lang('Email me when new opening times are added.') }}
                        </label>
                    </div>

                    <div class="field">
                        <label for="accept_terms" class="checkbox">
                            <input v-model="form.accept_terms" id="accept-terms" type="checkbox" :class="{'is-danger': formErrors.accept_terms}" name="accept_terms" required autocomplete="off">
                            <span v-html="acceptTermsLabel"></span>
                        </label>
                        <p v-show="formErrors.accept_terms" v-for="error in formErrors.accept_terms" :key="error" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>

                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-primary">{{ lang('Register') }}</button>
                            <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            form: {
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                event_notifications: 0,
                accept_terms: 0
            },
            loading: false,
            isAuthenticated: this.$auth.check,
            successfullyRegistered: false,
            redirectPath: '/',
            formErrors: {},
            acceptTermsLabel: ""
        };
    },
    methods: {
        onSubmit() {
            var self = this;
            this.loading = true;
            axios
                .post("/register", self.form)
                .then(function(response) {
                    if (response.data.success) {
                        self.isAuthenticated = true;
                        self.successfullyRegistered = true;
                    }
                    if (response.data.redirect) {
                        self.redirectPath = response.data.redirect;
                    }
                    self.loading = false;
                })
                .catch(function(error) {
                    self.loading = false;
                    if (
                        error.response.status == 422 &&
                        error.response.data.errors
                    ) {
                        self.formErrors = error.response.data.errors;
                    } else {
                        console.log(error.response.data.message);
                    }
                });
        }
    },
    mounted() {
        this.acceptTermsLabel = this.lang("I understand and accept that the submitted info will be stored by Leben bewegt e.V. See our <a href=\":url\" target=\"_blank\">Privacy Policy</a> for more details.", {'url': 'https://lebenbewegt-ev.de/index.php/privacy-policy/'});
    }
};
</script>
